import React, {useState, useRef, useEffect} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t,getLanguage} from 'react-switch-lang';
import {
  getAllTypeGainLosses,
  createTypeGainLoss,
  deleteTypeGainLoss,
  updateTypeGainLoss,
} from '../../../services/TypeGainLossService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './TypeGainLoss.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';

const TypeGainLoss = () => {
  const [typeGainLoss, setTypeGainLoss] = useState([]);
  const [query, setQuery] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllTypeGainLosses();
        setTypeGainLoss(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('typeGainLoss.name'),
      editable: true,
      placeholder: t('typeGainLoss.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('typeGainLoss.nameEn'),
      editable: true,
      placeholder: t('typeGainLoss.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateTypeGainLoss(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('typeGainLoss.message.updateSuccess', {
            entity: t('typeGainLoss.typeGainLos'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.typeGainLossExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.typeGainLossExists')],
          },
        ]);
      }
    }
  };
  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createTypeGainLoss(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('typeGainLoss.message.addSuccess', {
            entity: t('typeGainLoss.typeGainLos'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.typeGainLossExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.typeGainLossExists')],
          },
        ]);
      }
    }
  };
  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteTypeGainLoss'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete'),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteTypeGainLoss(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('typeGainLoss.message.deleteSuccess', {
                  entity: t('typeGainLoss.typeGainLos'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {}
        },
      });
    });
  };
  const addButton = useRef();
  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('typeGainLoss.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('typeGainLoss.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/type-gain-losses"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        queryParamName="name.contains"
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default TypeGainLoss;
